import React from "react";

export default function wrong() {
  return <h1>Ops...</h1>;
}
